import React, { useEffect, useState } from 'react';

const ADMIN_ID = 1113508465; // <-- вставь сюда свой Telegram ID

function App() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [checked, setChecked] = useState(false); // флаг, что проверка выполнена

  useEffect(() => {
    // Проверяем, есть ли Telegram WebApp
    if (window.Telegram?.WebApp) {
      const userId = window.Telegram.WebApp.initDataUnsafe?.user?.id;
      setIsAdmin(userId === ADMIN_ID);
      setChecked(true);
    } else {
      // Если запускаем локально вне Telegram — даём полный доступ для удобства разработки
      setIsAdmin(true);
      setChecked(true);
    }
  }, []);

  if (!checked) {
    // Пока не проверили - можно показать загрузку или пустой экран
    return <div>Загрузка...</div>;
  }

  if (!isAdmin) {
    return (
      <div className="p-4 text-center text-red-600">
        У вас нет доступа к этому приложению.
      </div>
    );
  }

  return (
    <div className="p-4">
      <h1>Добро пожаловать, админ!</h1>
      {/* Здесь размести остальной функционал */}
    </div>
  );
}

export default App;
